import { DefaultApiGetDataImportsRequest } from "@coeff/api-admin-ext";
import React from "react";

import { FlexRow, Tag } from "../../../components";
import { ExportCSVButton } from "../../WorkspaceAdmin/ExportCSVButton";
import { TabName } from "../../WorkspaceAdmin/WorkspaceAdmin";
import { TableFilters } from "../useTableFilters";

import { DebouncedSearchInput } from "./DebouncedSearchInput";
import {
  DataSourceFilterPopover,
  ScheduleFilterPopover,
  RunStatusFilterPopover,
  UserFilterPopover,
} from "./FilterPopovers";

type Props = {
  domain: string;
  initialSearch: string;
  onSearchChange: (search: string) => void;
  filters: TableFilters<keyof DefaultApiGetDataImportsRequest>;
  setFilters: (filters: TableFilters<keyof DefaultApiGetDataImportsRequest>) => void;
};

export const DataImportsFilterToolbar: React.FC<Props> = ({
  domain,
  onSearchChange,
  initialSearch,
  filters,
  setFilters,
}) => {
  const dataSourceId = filters.data_source_id?.[0];

  return (
    <FlexRow style={{ justifyContent: "space-between" }}>
      <FlexRow style={{ flex: 1 }}>
        <DebouncedSearchInput initialSearch={initialSearch} onChange={onSearchChange} />

        {dataSourceId ? (
          <Tag
            closable
            onClose={() =>
              setFilters({
                ...filters,
                data_source_id: undefined,
              })
            }
          >
            <b>Source:</b> {dataSourceId}
          </Tag>
        ) : null}
      </FlexRow>

      <FlexRow>
        <DataSourceFilterPopover
          domain={domain}
          table="data_imports"
          values={filters.data_source_type}
          onChange={values =>
            setFilters({
              ...filters,
              data_source_type: values,
            })
          }
        />

        <UserFilterPopover
          domain={domain}
          table="data_imports"
          values={filters.user_id}
          onChange={values =>
            setFilters({
              ...filters,
              user_id: values,
            })
          }
        />

        <RunStatusFilterPopover
          values={filters.status}
          onChange={values =>
            setFilters({
              ...filters,
              status: values,
            })
          }
        />

        <ScheduleFilterPopover
          domain={domain}
          values={filters.schedule}
          onChange={values =>
            setFilters({
              ...filters,
              schedule: values,
            })
          }
        />

        <ExportCSVButton tab={TabName.imports} />
      </FlexRow>
    </FlexRow>
  );
};
